<template>
	<auth-link v-if="to && !$listeners.click" :to="to" :title="title" :class="cssClasses" v-on="$listeners">
		<i class="material-icons">{{icon}}</i>
	</auth-link>
	<span v-else :class="cssClasses" v-on="$listeners" :title="title">
		<i class="material-icons">{{icon}}</i>
	</span>
</template>

<script>
export default {
	props: ['icon', 'to', 'color', 'title'],
	data() {
		return {
			cssClasses: [
				'circle-button',
				this.color || 'dark-blue',				
			]
		}
	}
}
</script>

<style scoped>
.circle-button {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	width: 50px;
	height: 50px;
	margin-top: 5px;
	margin-bottom: 5px;
	z-index: 1;
	cursor: pointer;
	box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);        
  	transition: transform 600ms ease-in-out;
	user-select: none;
}

.circle-button i {
	color: #FFF;
	transition-duration: 1s;
}

.aquamarine {
	background-color: #0AC6B7;
	border-color: #02BDA8;        
}

.purple {
	background-color: #47276B;
	border-color: #40385C;        
}

.light-purple {
	background-color: #8768AB;
	border-color: #80799C;        
}    

.dark-blue {
	background-color: #163247;
	border-color: #042035;        
}        

.grey {
	background-color: #8e9294;
	border-color: #949798;        
}
</style>


// WEBPACK FOOTER //
// src/components/shared/CircleButton.vue